import dayjs from 'dayjs';

const formatNonZeroAvailabilityForDaysOfWeek = (
  workingDaysArray: number[],
): string => {

  const daysSet = new Set(
    workingDaysArray
      .map((el) => dayjs(el*1000).format('d'))
      .map((el) => Number(el))
      .sort()
  );

  if (daysSet.size === 7) {
    return 'every day of the week';
  }
  const days = [...daysSet];
  const daysNames = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ].filter((_, i) => daysSet.has(i));

  const isGapBetweenAllDaysEq1 = days.every(
    (_, i) => !days[i + 1] || days[i + 1] - days[i] === 1
  );

  if (!daysNames[0]) {
    return '';
  }

  if (isGapBetweenAllDaysEq1) {
    return `from ${daysNames[0]} - ${daysNames[daysNames.length - 1]}`;
  }

  return `on ${daysNames.join(', ')}`;
};

export default formatNonZeroAvailabilityForDaysOfWeek;

